/*
 * @Description: Vue Router 4 版本
 * @Author: 王天琦
 * @Date: 2022-06-08 08:46:50
 * @Updated: 2024 - Vue 3 升级
 */
import { createRouter, createWebHistory } from 'vue-router'

// Vue Router 4 不再需要 Vue.use() 和 push 方法修复

const routes = [
	{ path: "/", redirect: "/home" },
	{
		path: '/targetManage',
		component: () => import('../components/TargetManage.vue'),
		meta: {id: 4}
	},
	{
		path: "/home",
		component: () => import("../components/Home2.vue"),
		meta: { id: 0 },
	},
	{
		name:'Manage',
		// 网关拦截 manage 前缀，路由改用 /gl 避开（name 保持 Manage 不变，按名跳转不受影响）
		path: "/gl",
		component: () => import("../components/Manage.vue"),
		meta: { id: 0 },
	},
	{
		path: "/apply",
		name: "apply",
		component: () => import("../components/NewManage.vue"),
		meta: { id: 0 },
	},
	{
		path: "/test-dialog",
		name: "test-dialog",
		component: () => import("../components/TestDialog.vue"),
		meta: { id: 0 },
	},
	{
		path: "/helper",
		component: () => import("../components/helpPage.vue"),
		meta: { id: 0 },
	},
	{
		path: "/report",
		component: () => import("../components/pdfDownload/index.vue"),
		meta: { id: 5 },
	},
	{
		path: "/guoGuanJuReport",
		component: () => import("../components/guoGuanJuReport/index.vue"),
		meta: { id: 5 },
	},
	{
		// 网关拦截 data/manage/admin 前缀，路由改用 /sjlr 避开
		path: "/sjlr",
		redirect: "/sjlr/manual",
		component: () => import("../components/DataGo.vue"),
		meta: { id: 3 },
		children: [
			{
				path: "manual",
				component: () => import("../components/Manual.vue"),
				meta: { id: 3 },
			},
			{
				path: "changecampu",
				component: () => import("../components/Changecampu.vue"),
				meta: { id: 0 },
			},
			{
				path: "daoru",
				component: () => import("../components/Daoruwenjian.vue"),
				meta: { id: 3 },
			},
		],
	},
	{
		path: "/register",
		component: () => import("../components/zhuchemanage.vue"),
		meta: { id: 7 },
	},
	{
		path: "/lurutable",
		component: () => import("../components/LuruTable.vue"),
		meta: { id: 3 },
	},
	{
		// 网关拦截 data 前缀，数据管理路由改用 /sjgl 避开
		path: "/sjgl",
		component: () => import("../components/CTablenewRouter.vue"),
		meta: { id: 4 },
	},
	{
		path: "/verify",
		component: () => import("../components/CTablenewRouter.vue"),
		meta: { id: 4 },
	},
	{
		path: "/tableexamine",
		component: () => import("../components/TableExamine.vue"),
		meta: { id: 4 },
	},
	{
		path: "/heduitable",
		component: () => import("../components/HeduiTable.vue"),
		meta: { id: 4 },
	},
	{
		path: "/heduitable303",
		component: () => import("../components/HeduiTable303.vue"),
		meta: { id: 4 },
	},
	{
		path: "/users",
		component: () => import("../components/UserManage.vue"),
		meta: { id: 7 },
	},
	{
		path: "/permission",
		component: () => import("../components/LimitManage.vue"),
		meta: { id: 7 },
	},
	{
		path: "/news",
		component: () => import("../components/XinwenManage.vue"),
		meta: { id: 7 },
	},
	{
		path: "/publicFactor",
		component: () => import("../components/PublicFactorManage.vue"),
		meta: { id: 12 },
	},
	{
		path: "/lurutable",
		component: () => import("../components/LuruTable.vue"),
		meta: { id: 3 },
	},
	{
		path: "/adduser",
		component: () => import("../components/AddUser.vue"),
		meta: { id: 7 },
	},
	{
		path: "/edituser",
		component: () => import("../components/editUser.vue"),
		meta: { id: 7 },
	},
	{
		path: "/addpermission",
		component: () => import("../components/AddPermission.vue"),
		meta: { id: 7 },
	},
	{
		path: "/editpermission",
		component: () => import("../components/editPermission.vue"),
		meta: { id: 7 },
	},
	{
		path: "/addnews",
		component: () => import("../components/AddXinwen.vue"),
		meta: { id: 7 },
	},
	{
		path: "/editnews",
		component: () => import("../components/editxinwen.vue"),
		meta: { id: 7 },
	},
	{
		path: "/error",
		name: "err",
		component: () => import("../components/Error404.vue"),
	},
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: () => import("../components/Error404.vue"),
	},
	{
		path: "/statuserror",
		name: "err",
		component: () => import("../components/Error0.vue"),
		meta: { id: 0 },
	},
];

// 根据环境设置路由base路径 - 与实际部署路径保持一致
// 从nginx.conf.fixed可以看到实际部署在根路径'/'下
const routerBase = '/';

const router = createRouter({
	history: createWebHistory(routerBase),
	routes,
});

export default router;
